import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    EditEventAttendeeMutation,
    EditEventAttendeeMutationVariables,
} from './List.mutations.generated'

export const CHECK_IN_GUEST: TypedDocumentNode<
    EditEventAttendeeMutation,
    EditEventAttendeeMutationVariables
> = gql`
    mutation editEventAttendee($input: editEventAttendeeInput!) {
        editEventAttendee(input: $input) {
            entity {
                guid
            }
        }
    }
`
